export default "__VITE_ASSET__Dzjg3Ngf__"